import { createFileRoute } from '@tanstack/react-router';
import BookmarkListPage from '../components/BookmarkListPage';
import { useUserPreferences } from '../hooks/useUserPreferences';
import { useLikedBookmarks } from '../services/dataHooks';

export const Route = createFileRoute('/_app/liked/read/$id')({
  component: LikedReadPage,
});

function LikedReadPage() {
  const { preferences } = useUserPreferences();
  const { bookmarks, isLoading: isBookmarkCollectionLoading } = useLikedBookmarks();

  return (
    <BookmarkListPage
      mode="liked"
      bookmarks={bookmarks}
      condensedView={preferences.bookmarkList.view === 'condensed'}
      showThumbnails={preferences.bookmarkList.thumbnails}
      isLoading={isBookmarkCollectionLoading}
    />
  );
}
